import { useNavigate } from "react-router-dom";

const Topbar = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/login", { replace: true });
  };

  return (
    <header className="h-16 bg-white border-b flex items-center justify-between px-6">
      <h1 className="font-semibold text-lg text-gray-800">
        Admin Dashboard
      </h1>

      <button
        onClick={logout}
        className="px-4 py-2 rounded bg-[#203d41] text-white hover:opacity-90"
      >
        Logout
      </button>
    </header>
  );
};

export default Topbar;
